module.exports = __webpack_public_path__ + "static/media/sample_loading_ports.28016d6f.csv";